import Compare from './Compare';
export default Compare;
